module.exports = __webpack_public_path__ + "img/hotel3_3.6a2ad4aa.png";